export default "__VITE_PUBLIC_ASSET__acff665e__"